/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskMCPServerScope = {
  /**
   * The selected MCP server or gateway ID.
   */
  mcpServerId: string;
  /**
   * Custom tool names for this server. Omit to follow the policy tool rule; an empty list matches every tool on this server, unconditionally.
   */
  tools?: Array<string> | undefined;
};

/** @internal */
export const RiskMCPServerScope$inboundSchema: z.ZodMiniType<
  RiskMCPServerScope,
  unknown
> = z.pipe(
  z.object({
    mcp_server_id: z.string(),
    tools: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      "mcp_server_id": "mcpServerId",
    });
  }),
);
/** @internal */
export type RiskMCPServerScope$Outbound = {
  mcp_server_id: string;
  tools?: Array<string> | undefined;
};

/** @internal */
export const RiskMCPServerScope$outboundSchema: z.ZodMiniType<
  RiskMCPServerScope$Outbound,
  RiskMCPServerScope
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
    tools: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
    });
  }),
);

export function riskMCPServerScopeToJSON(
  riskMCPServerScope: RiskMCPServerScope,
): string {
  return JSON.stringify(
    RiskMCPServerScope$outboundSchema.parse(riskMCPServerScope),
  );
}
export function riskMCPServerScopeFromJSON(
  jsonString: string,
): SafeParseResult<RiskMCPServerScope, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskMCPServerScope$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskMCPServerScope' from JSON`,
  );
}
